import { deleteFile } from 'core/classes/helpers/deleteFile'
import { saveFile } from 'core/classes/helpers/saveFiles'
import { IModels } from 'core/classes/models/IFileData'
import { Crud } from 'core/types/Crud'
import { fileApi, IAttachFileTarget, IDeleteFileTarget } from 'onboarding/api/fileApi'

class FileService {
  // Does not save any rows in DB, simply upload the file on server and attaches it to existing row.
  public uploadAndAttachOnServer(target: IAttachFileTarget, file: File, accessToken: string) {
    return fileApi.uploadAndAttachOnServer(target, file, accessToken)
  }

  // Does not delete any rows in DB, simply deletes the file on server.
  public deleteFromServer(target: IDeleteFileTarget, accessToken: string) {
    return fileApi.deleteFromServer(target, accessToken)
  }

  public saveInDBAndServer(target: ISaveTarget, models: IModels[], sourceToUpdateCache?: Crud) {
    // todo: has side-effect, calling processLoadFileError, which shows ui-notification
    return saveFile({
      ...target,
      models,
      source: sourceToUpdateCache,
    })
  }

  public deleteFromDBAndServer(
    target: IDeleteFileTarget & {
      formCode: string
      entryId: number
      fileName: string
    },
    sourceToUpdateCache?: Crud
  ) {
    const { formId, formCode, uid, entryId, field, fileName } = target

    // todo: has side-effect, calling processLoadFileError, which shows ui-notification
    return deleteFile({
      formId,
      formCode,
      entryId,
      fieldName: field,
      fileName,
      UID: uid,
      source: sourceToUpdateCache,
    })
  }
}

export const fileService = new FileService()

interface ISaveTarget {
  formId: number
  formCode: string
  fieldName: string
}
